document.addEventListener('DOMContentLoaded', function() {
  var countElement = document.getElementById('countup');
  if (!countElement) return;

  var currentCount = 1000;
  var targetCount = 10000;
  var duration = 2000;
  var frameRate = 30;
  var totalFrames = Math.round((duration / 1000) * frameRate);
  var frame = 0;

  var counter = setInterval(function() {
    frame++;
    var progress = frame / totalFrames;
    var easedProgress = 1 - Math.pow(1 - progress, 3);
    var count = Math.floor(currentCount + easedProgress * (targetCount - currentCount));
    countElement.textContent = count.toLocaleString();

    if (frame >= totalFrames) {
      clearInterval(counter);
      countElement.textContent = targetCount.toLocaleString();
    }
  }, duration / totalFrames);
});
